import { Component, OnDestroy, OnInit } from '@angular/core';
import { EMPTY } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { BadgesService } from '../../services/badges.service';
import { NotificationService } from '../../services/notification.service';
import { NoticeModuleName } from '../bx-notices/notices.enum';
import { Notice, NoticeTextItem } from '../bx-notices/notices.model';
import { NoticesService } from '../bx-notices/notices.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-bx-global-notifications',
    templateUrl: './bx-global-notifications.component.html',
    styleUrls: ['./bx-global-notifications.component.scss'],
    standalone: false,
})
export class BxGlobalNotificationsComponent implements OnInit, OnDestroy {
    showPanel = false;
    // @ts-ignore TS2564
    notices: Notice[];
    errorNotices = false;
    errorCounts = false;
    // @ts-ignore TS7008
    noticeCounts;
    private onNewNoticeCreatedProxy: any;
    private onNewNoticeReadProxy: any;

    constructor(
        private noticesService: NoticesService,
        private badgesService: BadgesService,
        private notificationService: NotificationService,
        private router: Router
    ) {}

    ngOnInit(): void {
        this.onNewNoticeCreatedProxy = this.onNewNoticeCreated.bind(this);
        this.onNewNoticeReadProxy = this.onNewNoticeRead.bind(this);
        this.notificationService.connection.on('NoticeCreated', this.onNewNoticeCreatedProxy);
        this.notificationService.connection.on('NoticeRead', this.onNewNoticeReadProxy);

        this.getNoticesByTenant();
        this.getBadgeCounts();
    }

    ngOnDestroy(): void {
        this.notificationService.connection.off('NoticeCreated', this.onNewNoticeCreatedProxy);
        this.notificationService.connection.off('NoticeRead', this.onNewNoticeReadProxy);
    }

    private getBadgeCounts() {
        this.noticeCounts = 0;
        this.badgesService
            .getBadgeCount()
            .pipe(
                map((response) => response?.data?.badges),
                catchError((e) => {
                    this.errorCounts = true;
                    return EMPTY;
                })
            )
            .subscribe((badges) => {
                if (badges) {
                    Object.keys(badges).forEach((e) => {
                        // @ts-ignore TS7053
                        this.noticeCounts += badges[e];
                    });
                }
            });
    }

    private getNoticesByTenant() {
        this.noticesService
            .getNoticesByTenant()
            .pipe(
                map((response) => response?.data?.noticesByTenant),
                catchError((e) => {
                    this.errorNotices = true;
                    return EMPTY;
                })
            )
            .subscribe((notices) => {
                if (notices) {
                    this.setupNotices(notices);
                    this.notices = [...notices];
                }
            });
    }

    onNewNoticeCreated(notice: Notice) {
        this.getNoticesByTenant();
        this.getBadgeCounts();
    }

    onNewNoticeRead() {
        this.getNoticesByTenant();
        this.getBadgeCounts();
    }

    showNotifications() {
        this.showPanel = true;
    }

    overlayClicked() {
        this.showPanel = false;
    }

    private getTranslateParams(textItems: NoticeTextItem[]) {
        const params = {};
        if (textItems) {
            textItems.forEach((item) => {
                // @ts-ignore TS7053
                params[item.key] = item.value;
            });
            return params;
        }
    }

    private setupNotices(notices: Notice[]) {
        notices.forEach((notice) => {
            this.setupNotice(notice);
        });
    }

    private setupNotice(notice: Notice) {
        // @ts-ignore TS2345
        notice.translateParams = this.getTranslateParams(notice.textItems);
    }

    noticeClick(notice: Notice) {
        // @ts-ignore TS2345
        this.noticesService.markRead(notice.noticeId).subscribe((response) => {
            this.showPanel = false;
            switch (notice.module) {
                case NoticeModuleName.Conversations:
                    this.router.navigate(['/messages', 'conversations'], {
                        queryParams: { subpanel: true, submenu: 'communications', open: true, choice: 'conversations' },
                    });
                    break;
                default:
                    this.router.navigate([`/${notice.module.toLowerCase()}`, 'list', notice.objectId, 'details']);
            }
        });
    }

    markAsReadChange(obj: { isRead: boolean; noticeId: string }) {
        if (obj.isRead) {
            this.noticesService.markRead(obj.noticeId).subscribe();
        } else {
            this.noticesService.markUnread(obj.noticeId).subscribe();
        }
    }

    noticeClose(noticeId: string) {
        const index = this.notices.findIndex((notice) => notice.noticeId === noticeId);
        if (index) {
            this.notices.splice(index, 1);
        }
        this.noticesService.deleteNotice(noticeId).subscribe((response) => {
            this.getNoticesByTenant();
            this.getBadgeCounts();
        });
    }
}
